import styles from "./ContactUs.module.css";
import pinLoc from "../../img/pin-de-localizacao.png";
import tel from "../../img/telefone.png";
import hora from "../../img/relogio.png";
import logo from "../../img/petshop.png";

function ContactUs(props) {
  return (
    <section {...props} className={styles.contact_container}>
      <img src={logo} alt="logotipo petshop catarina" className={styles.logo} />
      <div className={styles.infosContainer}>
        <h1>Contato</h1>
        <div className={styles.infos}>
          <img src={pinLoc} alt="icone localização" className={styles.image} />
          <div>
            <h3>Endereço Oficial</h3>
            <p>
              Rua Lourival Moreira do Amaral, 958, Parque São Vicente, São
              Vicente - SP.
            </p>
          </div>
        </div>

        <div className={styles.infos}>
          <img src={tel} alt="icone telefone" className={styles.image} />
          <div>
            <h3>Telefone</h3>
            <p>13 99608-5483</p>
          </div>
        </div>

        <div className={styles.infos}>
          <img src={hora} alt="icone relógio" className={styles.image} />
          <div>
            <h3>Horários</h3>
            <p>Seg - Dom das 8h às 20h</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
